// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 4.38574H20V15.9004L19.5811 16.1992L12 21.6143L4.41895 16.1992L4 15.9004V4.38574H2V2.38574H22V4.38574ZM9 13.3857H15V11.3857H9V13.3857ZM8 9.38574H16V7.38574H8V9.38574Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-contribute-filled')
export default class ContributeFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'contribute-filled',
    }
  }
}
